<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M11.4294 14.286C13.0074 14.286 14.2866 13.0069 14.2866 11.4289C14.2866 9.85097 13.0074 8.57178 11.4294 8.57178C9.85145 8.57178 8.57227 9.85097 8.57227 11.4289C8.57227 13.0069 9.85145 14.286 11.4294 14.286Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.4283 15.4283L13.4512 13.4512"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.00084 2.28557C8.00084 1.3388 7.23333 0.571289 6.28655 0.571289H0.572266V11.9998H6.28655"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 2.28564V7.4285"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 2.28557C8 1.3388 8.76751 0.571289 9.71429 0.571289H15.4286V8.57156"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
